import type { AuthMnemonic, AuthMnemonicBody } from '../types/mnemonic';

import { getAuthMnemonic } from './getAuthMnemonic';
import { isApiStatusError } from './isApiStatusError';

/** The message key of a failed auth request, if the error carries one. */
export function getAuthMnemonicFromError(err: unknown): AuthMnemonic | undefined {
    return getAuthMnemonic(isApiStatusError(err) ? (err.body as AuthMnemonicBody | undefined) : undefined);
}
